import React from 'react';
import { Provinces } from "util/constants";

const ChinaSubmissionSummaryText = (({ data,latestChinaSubmissionDate }) => {
    let result1 = ""
    let result = []
    if (data && data !== undefined && data.provinces && data.provinces !== undefined) {
        let provincesKeys = Object.keys(data.provinces)
        let numberOfProvinces = provincesKeys.length
        let latestSubmissionDate = data.latestSubmissionDate

        // result1 = numberOfProvinces + " Regions reporting their latest hCoV-19 data through GISAID, with samples collected as recent as " + latestSubmissionDate + " from "
        result1 = "总共" + numberOfProvinces + "个省市通过GISAID报告了他们最新的hCoV-19数据, 最近的样本采集时间是 " + latestChinaSubmissionDate + "。这些省市包括："
        result.push(<text>{result1}</text>)
        // let provinces:object=data.provinces

        for (let i = 0; i < provincesKeys.length; i++) {
            let province = provincesKeys[i]

            if (i === provincesKeys.length - 2) // last second province
                result.push(<a href={data.provinces[province]} style={{color: 'rgb(31, 119, 180)'}}  target="_blank">{Provinces[province]}</a>)
            else if (i === provincesKeys.length - 1) // last province
                result.push(<text> 和 <a href={data.provinces[province]} style={{color: 'rgb(31, 119, 180)'}} target="_blank">{Provinces[province]}</a></text>)
            else
                result.push(<text><a href={data.provinces[province]} style={{color: 'rgb(31, 119, 180)'}} target="_blank">{Provinces[province]}</a>, </text>)
        }

        result.push(<text>。 初步<a href={data.phylogeneticAnalysis}  style={{color: 'rgb(31, 119, 180)'}} target="_blank">系统发生树分析。</a></text>)
    }
    return (<div style={{ textAlign: "center",color: 'black',fontSize: 15 }}>
        {/* <text style={{ textAlign: "center" }}>{result1}</text> */}
        {result}
    </div>
    );
}
)

export default ChinaSubmissionSummaryText;